import { useEffect } from 'react';

let activeBannerCount = 0;

/**
 * Manages the shared `has-banner` CSS class on `document.documentElement`.
 * Multiple banners can be active simultaneously — the class is only removed
 * when all banners have deactivated or unmounted.
 */
export function useBannerClass(active: boolean) {
  useEffect(() => {
    if (!active) return;
    activeBannerCount++;
    document.documentElement.classList.add('has-banner');
    return () => {
      activeBannerCount--;
      if (activeBannerCount === 0) {
        document.documentElement.classList.remove('has-banner');
      }
    };
  }, [active]);
}
